import SettingCard from "@/components/SettingCard";
import ClassSettings from "./ClassSettings";
import { Stack } from "@mui/material";

const RepeatSettings = () => {
    return (
        <Stack spacing={2}>
            <SettingCard title="Clase Css">
                <ClassSettings />
            </SettingCard>
        </Stack>
    );
};

export default RepeatSettings;